<template>
  <div>
    <Title :pages="[{ icon: 'folder', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-row class="mt-1">
        <v-col cols="12" md="6">
          <v-btn color="primary" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="search" append-icon="search" label="Buscar" outlined dense hide-details></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-4">
        <v-col cols="12" md="12">
        <Breadcrumbs
          :navigationStack="navigationStack"
          :selectedFolder="selectedFolder"
          @reset-navigation="resetNavigation"
          @go-to-folder="goToFolder"
        />

        </v-col>
      </v-row>

      <Modal v-if="create_access" :button_name="$t('Crear') + ' ' + modal_title" :modal_title="modal_title"
        :formBtn="formBtn" :dialog="dialog" :parent="parent" :service="service" @updateDialog="updateDialog"
        @loadList="loadList(service)" :item="mainItem" @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        " :selectedFolder="selectedFolder" />

      <ListFolder v-if="!selectedFolder" :folders="filteredFoldersView" @open-folder="openFolder"
        :loading_folders="loading" @editItem="editItem" @deleteItem="deleteItem" />
      <ListSubFolder v-else :folderData="filteredFoldersView" @go-back="goBack" @open-folder="openFolder" @editItem="editItem"
        @deleteItem="deleteItem" :loading_folders="loading" />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" :subtext="'Eliminarás todos los archivos y subcarpetas contenidos en ella en todos los legajos del sistema.'" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { folderService } from "@/libs/ws/folderService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ListFolder from "../../components/Folder/ListFolder.vue";
import ListSubFolder from "../../components/Folder/ListSubFolder.vue";
import Breadcrumbs from "../../components/Folder/Breadcrumbs.vue";

export default {
  components: { Title, Modal, DialogDelete, ListFolder, ListSubFolder, Breadcrumbs},
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: folderService,
      selectedFolder: null,
      navigationStack: [],

      page_title: "Carpetas",
      modal_title: "Carpeta",
      mainItem: {
        id: "",
        name: "",
        color: ""
      },
      defaultItem: null,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  computed: {
    filteredFoldersView() {
      const searchLower = this.search.toLowerCase();

      if (!this.selectedFolder) {
        // Si no hay carpeta seleccionada, devuelvo un array (para ListFolder)
        if (!this.search) {
          return this.list;
        }
        return this.list.filter(folder =>
          folder.name?.toLowerCase().includes(searchLower)
        );
      } else {
        // Si hay carpeta seleccionada, devuelvo el objeto con sub_folder y documents filtrados (para ListFile)
        if (!this.search) {
          return this.selectedFolder;
        }

        const filteredSubFolders = (this.selectedFolder.sub_folder || []).filter(
          folder => folder.name?.toLowerCase().includes(searchLower)
        );
        return {
          ...this.selectedFolder,
          sub_folder: filteredSubFolders,
        };
      }
    }
  },
  watch: {
    list: {
      immediate: true,
      handler(newVal) {
        this.list = newVal;
        // Mantengo la carpeta seleccionada actualizada
        if (this.selectedFolder) {
          const found = newVal.find(f => f.id === this.selectedFolder.id);
          this.selectedFolder = found || null;
          if (!found) {
            this.navigationStack = [];
          }
        }
      }
    }
  },

  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    
    openFolder(folder) {
      if (this.selectedFolder) {
        this.navigationStack.push(this.selectedFolder)
      }
      this.selectedFolder = folder
    },
    goBack() {
      this.selectedFolder = this.navigationStack.pop() || null
    },
    goToFolder(index) {
      this.selectedFolder = this.navigationStack[index]
      this.navigationStack = this.navigationStack.slice(0, index)
    },
    resetNavigation() {
      this.selectedFolder = null
      this.navigationStack = []
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
